import { message } from "antd";
import { useDispatch } from "react-redux";
import {
  setBailiffDocumentOpenPay,
  setBailiffDocumentSelected,
} from "store/bailiff/bailiff/document/bailiff_document.action";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useBailiffPayment = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleSelect = async (data) => {
    dispatch(setBailiffDocumentSelected(data));
    dispatch(setBailiffDocumentOpenPay(true));
  };

  const handleClose = () => {
    dispatch(setBailiffDocumentOpenPay(false));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleSelect, handleClose };
};
